import React, { Component } from "react";
import { Row, Col, Button, Modal, Container, Form } from "react-bootstrap";
import Switch from "react-switch";
import { toast } from "react-toastify";
import "./AddBank.css";
import "react-toastify/dist/ReactToastify.css";

class AddBank extends Component {
  constructor(props) {
    super(props);
    this.state = {
      value: {
        name: "",
        code: "",
        desc: "",
        isActive: true
      }
    };
  }
  handleChange = checked => {
    this.setState({ value: { ...this.state.value, isActive: checked } });
  };
  onChange = event => {
    let name = event.target.name;
    let value = event.target.value;

    if (name == "name") {
      this.setState({
        value: { ...this.state.value, name: value }
      });
    } else if (name == "code") {
      this.setState({
        value: { ...this.state.value, code: value }
      });
    }
    else if (name == "desc") {
      this.setState({
        value: { ...this.state.value, desc: value }
      });
    }
    else if (name == "isActive") {
      this.setState({
        value: { ...this.state.value, isActive: value }
      });
    }
  };

  submit = () => {
    let data = this.state.value;
    if (
      data.name === "" &&
      data.code === "" &&
      data.desc === ""
    ) {
      toast.error("Please fill out this field", {
        autoClose: 2000,
        position: toast.POSITION.TOP_CENTER
      });
    } else {
      this.props.AddBank(data);
      this.setState({
        value: {
          name: "",
          code: "",
          desc: "",
          isActive: true
        }
      });
      this.props.closeAddModel();
      this.props.resetPage();
    }
  };

  closeModel = () => {
    this.setState({
      value: {
        name: "",
        code: "",
        desc: "",
        isActive: true
      }
    });
    this.props.closeAddModel();
  };
  render() {
    return (
      <div>
        <Modal
          show={this.props.showAddModel}
          onHide={this.closeModel}
          animation={false}
          size="md"
          backdrop="static"
        >
          <Modal.Header
            style={{ fontSize: "35px", backgroundColor: "#f0f3f5" }}
            closeButton
          >
            <Modal.Title>Bank</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Container>

              <Form>
                <Row>
                  <Col lg={6} sm={12} xs={12}>

                    <Form.Group controlId="name">
                      <Form.Label> Bank Name</Form.Label>
                      <Form.Control
                        type="text"
                        // placeholder="Name"
                        autoComplete="off"
                        name="name"
                        onChange={this.onChange}
                      />
                    </Form.Group>
                  </Col>
                  <Col lg={6} sm={12} xs={12}>
                    <Form.Group controlId="code">
                      <Form.Label> Bank Code</Form.Label>
                      <Form.Control
                        type="text"
                        name="code"
                        autoComplete="off"
                        onChange={this.onChange}
                      />
                    </Form.Group>

                  </Col>
                </Row>
                <Row>
                <Col lg={6} sm={12} xs={12}>
                    <Form.Group controlId="desc">
                      <Form.Label> Description</Form.Label>
                      <Form.Control
                        type="text"
                        name="desc"
                        autoComplete="off"
                        onChange={this.onChange}
                      />
                    </Form.Group>

                  </Col>

                  <Col lg={6} sm={12} xs={12}>
                    <label style={{ display: "flex", marginTop: "0px" }}>
                      <Form.Group controlId="isActive">
                        <Form.Label> Active</Form.Label>
                        <div style={{ marginTop: "0px", marginLeft: "10px" }}>
                          <Switch
                            onChange={this.handleChange}
                            onColor="#20a8d8"
                            checked={this.state.value.isActive}
                          />
                        </div>
                      </Form.Group>
                    </label>
                  </Col>
                </Row>
              </Form>
            </Container>
          </Modal.Body>
          <Modal.Footer style={{ backgroundColor: "#f0f3f5" }}>
            <Button type="submit" onClick={this.submit}>
              Submit
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    );
  }
}

export default AddBank;
